import { Routes } from '@angular/router';
import { PersongbDetailComponent } from './detail/persongb-detail.component';
import { PersongbSucheComponent } from './suche/persongb-suche.component';
import { canActivateAuthorization } from '../../security/authorization.guard';
import { ErweiterungConfigResponse, PermissionResponse } from '../../core/base-api';
import { VergleichGbZpvComponent } from './vergleich/vergleich-gb-zpv.component';
import { PersonGbResolver } from './vergleich/gb-person-resolver';
import { canActivateErweiterung } from 'app/security/erweiterung.guard';
import { canActivateKanton } from 'app/security/kanton.guard';
import PermissionsEnum = PermissionResponse.PermissionsEnum;
import ActiveErweiterungenEnum = ErweiterungConfigResponse.ActiveErweiterungenEnum;

export const PersonGbRoutes: Routes = [
  {
    path: 'persongb',
    loadChildren: () => routes,
    providers: [PersonGbResolver]
  }
];

const routes: Routes = [
  {
    path: '',
    component: PersongbSucheComponent,
    canActivate: [canActivateAuthorization],
    data: {
      permissions: [
        PermissionsEnum.EIGENTUEMER_REGISTER,
        PermissionsEnum.UEBRIGE_BERECHTIGTE_REGISTER,
        PermissionsEnum.GLAEUBIGER_REGISTER
      ],
      breadcrumb: 'person.breadcrumbSuche',
      breadcrumbStatus: 'firstLevel'
    }
  },
  {
    path: 'detail',
    component: PersongbDetailComponent,
    canActivate: [canActivateAuthorization],
    data: {
      permissions: [
        PermissionsEnum.ANZEIGE_ANMERKUNGEN,
        PermissionsEnum.ANZEIGE_DIENSTBARKEITEN,
        PermissionsEnum.ANZEIGE_EIGENTUM,
        PermissionsEnum.ANZEIGE_GRUNDLASTEN,
        PermissionsEnum.ANZEIGE_VORMERKUNGEN,
        PermissionsEnum.ANZEIGE_PFANDRECHTE
      ]
    }
  },
  {
    path: 'vergleich',
    component: VergleichGbZpvComponent,
    canActivate: [canActivateAuthorization, canActivateErweiterung, canActivateKanton],
    data: {
      permissions: [PermissionsEnum.ANZEIGE_VERGLEICH_GRUNDBUCH_ZPV_PERSON],
      erweiterung: [ActiveErweiterungenEnum.ZENTRALE_PERSONEN_ZPV],
      kanton: ['BE']
    },
    resolve: {
      entity: PersonGbResolver
    }
  }
];
